import hijri from "hijri";
// import HijriDate from "hijri-date";
var wdNames = new Array(
  "الأحد",
  "الاثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت"
);
var moment = require("moment-hijri");

function getAllHijirDate() {
  console.log("FIRST DAY OF year", firstDayOfYear());
  console.log("IN HIJRI :", hijri.convert(firstDayOfYear()));
  const TODAY = hijri.convert(new Date());
  console.log("TODAY IS : ", hijri.convert(new Date()));
  moment.locale("ar-SA");
  console.log(moment().format("iYYYY/iM/iD").split("/"));
  let today = firstDayOfYear();
  let yesterday = firstDayOfYear();
  yesterday.setDate(yesterday.getDate() - 1);
  let todayHijri = hijri.convert(today);
  const NEXT_YEAR = todayHijri.year + 1;

  let oldDate = hijri.convert(yesterday);
  let month = new MonthModel(todayHijri);
  let result = [];

  let day = 1;
  let currentMonth = 1;
  let isFinshMonth = false;
  while (todayHijri.year !== NEXT_YEAR) {
    isFinshMonth = false;
    if (
      TODAY.dayOfMonth === todayHijri.dayOfMonth &&
      TODAY.month === todayHijri.month &&
      TODAY.year === todayHijri.year
    ) {
      console.log("IT IS CURRENT ");
      console.log(TODAY);
      todayHijri.current_today = true;
    }
    if (oldDate.month === todayHijri.month) {
      month.addDate(todayHijri);
    } else {
      month = new MonthModel(todayHijri);
      isFinshMonth = true;
    }
    if (isFinshMonth) result.push(month);

    currentMonth = todayHijri.month;
    today.setDate(today.getDate() + day);
    oldDate = todayHijri;
    todayHijri = hijri.convert(today);
  }
  console.log("CURRENT month ");
  console.log(result);
  return result;
}
class MonthModel {
  constructor(date) {
    this.monthName = date.monthText;
    this.year = date.year;
    this.month = date.month;
    this.date = [date];
    this.day = date.dayOfMonth;
  }
  addDate(date) {
    this.date.push(date);
  }
}
function firstDayOfYear() {
  let today = new Date();
  let todayHijri = hijri.convert(today);
  const CURRENT_YEAR = todayHijri.year;

  while (true) {
    if (
      todayHijri.month === 1 &&
      todayHijri.dayOfMonth === 1 &&
      todayHijri.year === CURRENT_YEAR
    ) {
      return today;
    }
    today.setDate(today.getDate() - 1);
    todayHijri = hijri.convert(today);
  }
}
export default getAllHijirDate;
